import { openBlock as t, createElementBlock as l, createStaticVNode as h } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ h('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M32.178 4.133c-7.16-5.51-17.195-5.51-24.356 0L20 16.311 32.178 4.133ZM20 23.69 7.822 35.866c7.16 5.51 17.195 5.51 24.356 0L20 23.689Z"></path><path fill="#6DA544" d="M16.31 20 4.134 7.822c-5.51 7.16-5.51 17.195 0 24.356L16.311 20Zm7.38 0 12.177 12.178c5.51-7.16 5.51-17.195 0-24.356L23.689 20Z"></path><path fill="#F0F0F0" d="M20 28.696a8.696 8.696 0 1 0 0-17.391 8.696 8.696 0 0 0 0 17.39Z"></path><path fill="#D80027" d="m20 13.913.753 1.304h1.506l-.753 1.305.753 1.304h-1.506L20 19.131l-.753-1.305H17.74l.753-1.304-.753-1.304h1.506L20 13.912ZM16.172 20l.753 1.305h1.506l-.753 1.304.753 1.304h-1.506l-.753 1.305-.753-1.305h-1.506l.753-1.304-.753-1.305h1.506L16.172 20Zm7.656 0 .753 1.305h1.506l-.753 1.304.753 1.304H24.58l-.753 1.305-.753-1.305h-1.506l.753-1.304-.753-1.305h1.506L23.828 20Z"></path>', 5), o = [
  c
];
function a(n, i) {
  return t(), l("svg", e, [...o]);
}
const d = { render: a };
export {
  d as default,
  a as render
};
